import comboPositionsModalTemplate from '../templates/comboPositionsModal.html';

function comboPositionsModalDirective() {
    return {
        restrict: 'E',
        controller: function () {},
        controllerAs: 'comboPositionsModal',
        bindToController: true,
        scope: {
            positions: '<',
            activePosition: '<',
            activePositionId: '<?',
            onSelectPosition: '&',
            onEditOptions: '&',
            priceAdded: '<?',
            close: '&?',
            positionCustomOptions: '<?',
            currencySymbol: '<',
        },
        templateUrl: comboPositionsModalTemplate,
    };
}

export { comboPositionsModalDirective };
